type PortalHost = HTMLElement & { __modalPortalRoot?: HTMLDivElement };

export function getModalPortalRoot(host: HTMLElement): HTMLDivElement {
  const portalHost = host as PortalHost;
  if (portalHost.__modalPortalRoot?.isConnected) {
    return portalHost.__modalPortalRoot;
  }

  const root = document.createElement('div');
  root.dataset.modalPortal = '';
  document.body.appendChild(root);
  portalHost.__modalPortalRoot = root;
  return root;
}

export function renderModalPortal(host: HTMLElement, markup: string): HTMLDivElement {
  const root = getModalPortalRoot(host);
  root.innerHTML = markup;
  return root;
}

export function clearModalPortal(host: HTMLElement): void {
  const portalHost = host as PortalHost;
  portalHost.__modalPortalRoot?.remove();
  delete portalHost.__modalPortalRoot;
}
